import { AuthService } from './../../services/auth.service';
import { CommonService } from './../../services/common.service';
import { DbService } from './../../services/db.service';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AlertDesignComponent } from '../alert-design/alert-design.component';
import * as $ from 'jquery';

import { Validator } from 'src/app/validator';
import { AlertDesignOnebuttonComponent } from '../alert-design-onebutton/alert-design-onebutton.component';
import * as firebase from 'firebase/app';
import { map, switchMap, take } from 'rxjs/operators';
import { combineLatest, of } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';

@Component({
  selector: 'app-mypage',
  templateUrl: './mypage.component.html',
  styleUrls: ['./mypage.component.css'],
})
export class MypageComponent implements OnInit {
  myTab = 'myfeed';
  p1: number = 1;
  p2: number = 1;
  searchKeyword: string = '';

  schoolYear = ['1학년', '2학년', '3학년', '4학년', '5학년', '6학년'];

  schoolArea = [
    '서울특별시',
    '세종특별자치시',
    '인천광역시',
    '대전광역시',
    '광주광역시',
    '대구광역시',
    '울산광역시',
    '부산광역시',
    '경기도',
    '강원도',
    '충청북도',
    '충청남도',
    '경상북도',
    '경상남도',
    '전라북도',
    '전라남도',
    '제주도',
  ];

  emailArray: any = [
    'naver.com',
    'hanmail.net',
    'nate.com',
    'gmail.com',
    '직접입력',
  ];

  // 이메일
  public emailAddress = {
    emailid: '',
    emailaddr: '',
    emailaddr2: '',
  };

  public chage: any = {
    password: '',
    repassword: '',
    confirmPassword: '',
  };

  pageSize;
  p: number = 1;
  panelOpenState = false;
  list = [
    {
      title: '집에서 혼자 플레이를 진행할 수 있나요?',
      anser:
        '네, 가능합니다. \n 개인 플레이 버튼을 통해 플레이를 진행하시면 됩니다.',
    },
    {
      title: '집에서 혼자 플레이를 진행할 수 있나요?',
      anser:
        '네, 가능합니다. \n 개인 플레이 버튼을 통해 플레이를 진행하시면 됩니다.',
    },
    {
      title: '집에서 혼자 플레이를 진행할 수 있나요?',
      anser:
        '네, 가능합니다. \n 개인 플레이 버튼을 통해 플레이를 진행하시면 됩니다.',
    },
    {
      title: '집에서 혼자 플레이를 진행할 수 있나요?',
      anser:
        '네, 가능합니다. \n 개인 플레이 버튼을 통해 플레이를 진행하시면 됩니다.',
    },
    {
      title: '집에서 혼자 플레이를 진행할 수 있나요?',
      anser:
        '네, 가능합니다. \n 개인 플레이 버튼을 통해 플레이를 진행하시면 됩니다.',
    },
    {
      title: '집에서 혼자 플레이를 진행할 수 있나요?',
      anser:
        '네, 가능합니다. \n 개인 플레이 버튼을 통해 플레이를 진행하시면 됩니다.',
    },
    {
      title: '집에서 혼자 플레이를 진행할 수 있나요?',
      anser:
        '네, 가능합니다. \n 개인 플레이 버튼을 통해 플레이를 진행하시면 됩니다.',
    },
    {
      title: '집에서 혼자 플레이를 진행할 수 있나요?',
      anser:
        '네, 가능합니다. \n 개인 플레이 버튼을 통해 플레이를 진행하시면 됩니다.',
    },
    {
      title: '집에서 혼자 플레이를 진행할 수 있나요?',
      anser:
        '네, 가능합니다. \n 개인 플레이 버튼을 통해 플레이를 진행하시면 됩니다.',
    },
    {
      title: '집에서 혼자 플레이를 진행할 수 있나요?',
      anser:
        '네, 가능합니다. \n 개인 플레이 버튼을 통해 플레이를 진행하시면 됩니다.',
    },
    {
      title: '집에서 혼자 플레이를 진행할 수 있나요?',
      anser:
        '네, 가능합니다. \n 개인 플레이 버튼을 통해 플레이를 진행하시면 됩니다.',
    },
    {
      title: '집에서 혼자 플레이를 진행할 수 있나요?',
      anser:
        '네, 가능합니다. \n 개인 플레이 버튼을 통해 플레이를 진행하시면 됩니다.',
    },
    {
      title: '집에서 혼자 플레이를 진행할 수 있나요?',
      anser:
        '네, 가능합니다. \n 개인 플레이 버튼을 통해 플레이를 진행하시면 됩니다.',
    },
    {
      title: '집에서 혼자 플레이를 진행할 수 있나요?',
      anser:
        '네, 가능합니다. \n 개인 플레이 버튼을 통해 플레이를 진행하시면 됩니다.',
    },
    {
      title: '집에서 혼자 플레이를 진행할 수 있나요?',
      anser:
        '네, 가능합니다. \n 개인 플레이 버튼을 통해 플레이를 진행하시면 됩니다.',
    },
  ];

  gallerys: any = [];
  allFaqs$;
  faqs$;
  notices$;

  eventRef: string = 'event/C0CeF4KTGMhen7SzuZ3Z';
  eventSwitch: boolean = false;

  public profile = {
    studentId: '',
    email: '',
    teacherCode: '',
    name: '',
    gender: '',
    region: 'placeholder',
    grade: 'placeholder',
    school: '',
  };

  public check = {
    id: '',
    password: '',
  };

  passwordTrue;

  public userId;
  public user$;

  public allFeed;
  chagePassword = false;
  checkValid;
  user;

  constructor(
    public dialog: MatDialog,
    private router: Router,
    public db: DbService,
    public auth: AuthService,
    private common: CommonService,
    private spinner: NgxSpinnerService
  ) {
    // this.userId = this.authService.userDetails().uid;
    this.userId = localStorage.getItem('userId');
    this.user$ = this.db
      .docOne$(`student/${this.userId}`)
      .pipe(take(1))
      .subscribe((data) => {
        this.user = data;
        let email = data.email;
        let emaildataArray = email.split('@');
        console.log('emaildataArray', emaildataArray);
        this.emailAddress.emailid = emaildataArray[0];
        if (String(emaildataArray[1]) == 'naver.com') {
          this.emailAddress.emailaddr = String(emaildataArray[1]);
        } else if (String(emaildataArray[1]) == 'hanmail.net') {
          this.emailAddress.emailaddr = String(emaildataArray[1]);
        } else if (String(emaildataArray[1]) == 'nate.com') {
          this.emailAddress.emailaddr = String(emaildataArray[1]);
        } else if (String(emaildataArray[1]) == 'gmail.com') {
          this.emailAddress.emailaddr = String(emaildataArray[1]);
        } else {
          this.emailAddress.emailaddr2 = String(emaildataArray[1]);
        }

        // this.profile = {
        //   studentId: this.userId,
        //   email: this.user.email,
        //   teacherCode: this.user.teacherCode,
        //   name: this.user.name,
        //   gender: this.user.gender,
        //   region: this.user.region,
        //   grade: this.user.grade,
        //   school: this.user.school,
        // };
      });

    this.allFeed = this.db
      .collection$(`student`, (ref) =>
        ref.where('studendId', '==', this.userId)
      )
      .pipe(
        switchMap((playfeed: any) => {
          if (playfeed.length > 0) {
            let feeds$ = [];
            const feed = playfeed[0].allPlayFeed;

            feed.forEach((cardInfo) => {
              let tmp$ = this.db.doc$(`playUser/${cardInfo}`);
              feeds$.unshift(tmp$);
            });

            if (feeds$.length > 0) {
              return combineLatest(feeds$);
            } else {
              return of([]);
            }
          } else {
            return of([]);
          }
        })
      )
      .pipe(
        map((feed: any) => {
          if (feed.length > 0) {
            return feed.sort((a, b) => {
              return a.dateCreated > b.dateCreated
                ? -1
                : a.dateCreated < b.dateCreated
                  ? 1
                  : 0;
            });
          } else {
            return [];
          }
        })
      );

    this.db.collection$(`gallerys`).subscribe(galleys => {
      this.gallerys = [];
      galleys.forEach(galley => {
        this.gallerys.push(galley.myFeedcardId);
      });
    })

    this.allFaqs$ = this.db.collection$(`faq`, ref => ref.orderBy('dateCreated', 'desc'));
    this.faqs$ = this.allFaqs$;
    this.notices$ = this.db.collection$(`notice`, ref => ref.orderBy('dateCreated', 'desc'));
  }

  ngOnInit(): void {
    this.db.doc$(this.eventRef).subscribe((event) => {
      console.log('Event', event);
      const now = new Date().getTime();
      const start = new Date(event.startdate).getTime();
      const end = new Date(event.enddate).getTime();
      if (now >= start && end >= now) {
        this.eventSwitch = true;
      } else {
        this.eventSwitch = false;
      }
    })

  }

  searchFaq() {
    this.faqs$ = this.allFaqs$.pipe(map((faqs: any) => {
      console.log('Fap', faqs)
      return faqs.filter(ele => ele.title.indexOf(this.searchKeyword) > -1);
    }));
  }

  focus(ev) {
    if (ev) {
      this.checkValid = false;
    }
  }

  pwdCheck(user): any {
    // let passwordTrue = false;
    console.log(user);
    this.spinner.show();
    const check = {
      email: `${user.id}@gmail.com`,
      password: this.check.password,
    };
    console.log('user.id', user.id);
    this.auth
      .loginUser(check)
      .then((success) => {
        console.log('Success', success);
        this.spinner.hide();
        this.passwordTrue = true;
        window.scroll(0, 0);
      })
      .catch((error) => {
        this.passwordTrue = false;
        this.checkValid = true;
        this.check.password = '';
        this.spinner.hide();
        console.log('Error', error);
      });
  }

  //프로필 수정
  editSubmit() {
    let email = '';
    if (this.emailAddress.emailaddr == '직접입력') {
      email = `${this.emailAddress.emailid}@${this.emailAddress.emailaddr2}`;
      console.log('email', email);
    } else {
      email = `${this.emailAddress.emailid}@${this.emailAddress.emailaddr}`;
      console.log('email', email);
    }
    this.db.updateAt(`student/${this.userId}`, {
      studendId: this.userId,
      email: email,
      teacherCode: this.user.teacherCode,
      name: this.user.name,
      gender: this.user.gender,
      region: this.user.region,
      grade: this.user.grade,
      school: this.user.school,
      // exitSwitch: this.account.exitSwitch,
    });
  }

  profileEdit(): any {
    const dialogRef = this.dialog.open(AlertDesignComponent, {
      data: {
        txt: '입력하신 정보로 저장하시겠습니까?',
      },
    });

    dialogRef.afterClosed().subscribe((data) => {
      console.log('data', data);
      if (data.data == 'ok') {
        this.editSubmit();
        this.passwordTrue = false;
        this.check.password = '';
      }
    });
  }

  //올리기 버튼
  openUpLoad(feedId): any {
    if (this.eventSwitch) {
      if (this.gallerys.indexOf(feedId) > -1) { // 이미 올린 경우

      } else {
        const dialogRef = this.dialog.open(AlertDesignComponent, {
          data: {
            txt: '갤러리에 올리시겠습니까?',
            sub: '(갤러리에 올리면 다른 사람들에게\n 본인의 게시글이 보여집니다.)',
          },
        });

        dialogRef.afterClosed().subscribe((data) => {
          console.log('data', data);
          if (data.data == 'ok') {

            const updateData = {
              galleryId: this.common.generateFilename(),
              dateCreated: new Date().toISOString(),
              myFeedcardId: feedId,
              reviewsId: [],
              likes: []
            };

            this.db.updateAt(`gallerys/${updateData.galleryId}`, updateData).then(() => {
              console.log("올리기 완료");
            })
          }
        });
      }
    } else {
      const dialogRef = this.dialog.open(AlertDesignOnebuttonComponent, {
        data: { txt: '지금은 갤러리 이벤트 진행기간이 아닙니다.' },
      });


    }
  }

  //삭제 버튼
  openRemove(feed): any {
    const dialogRef = this.dialog.open(AlertDesignComponent, {
      data: {
        txt: '지우시겠습니까?',
        sub: '(삭제하면 다시 복구할 수 없습니다.)',
      },
    });

    dialogRef.afterClosed().subscribe((data) => {
      console.log('data', data);
      if (data.data == 'ok') {
        console.log('삭제');
        console.log('FEED', feed);
        this.db.updateAt(`student/${this.userId}`, {
          allPlayFeed: firebase.default.firestore.FieldValue.arrayRemove(feed),
        });
      }
    });
  }

  //회원탈퇴
  openExit(): any {
    const dialogRef = this.dialog.open(AlertDesignComponent, {
      data: {
        type: 'leftOk',
        txt: '회원 탈퇴하시겠습니까?',
        sub: '(탈퇴한 계정은 복구할 수 없습니다.)',
      },
    });

    dialogRef.afterClosed().subscribe((data) => {
      console.log('data', data);
      if (data.data == 'ok') {
        this.auth.exitUser();
        this.router.navigate(['/login']);
      }
    });
  }

  changePassword() {
    this.spinner.show();

    var user = firebase.default.auth().currentUser;
    firebase.default
      .auth()
      .signInWithEmailAndPassword(user.email, this.chage.password)
      .then((sucess) => {
        user
          .updatePassword(this.chage.repassword)
          .then((sucess) => {
            this.spinner.hide();
            this.openOkChange();
          })
          .catch((error) => {
            this.spinner.hide();
            console.log('error', error);
            let code = error['code'];
            const dialogRef = this.dialog.open(AlertDesignOnebuttonComponent, {
              data: {
                txt: '다시 한번 시도해 주세요.',
              },
            });

            // this.failPassword();
            // this.alert.showErrorMessage(code);
          });
      })
      .catch((error) => {
        this.spinner.hide();
        let code = error['code'];
        // this.alert.showErrorMessage(code);
      });
  }

  //비밀번호 변경후
  openOkChange(): any {
    const dialogRef = this.dialog.open(AlertDesignOnebuttonComponent, {
      data: {
        txt: '비밀번호가 변경되었습니다.',
      },
    });

    dialogRef.afterClosed().subscribe((data) => {
      console.log('data', data);
      if (data.data == 'ok') {
        this.passwordTrue = true;
        this.chagePassword = false;
      }
    });
  }

  lastPage() {
    this.p1 = Math.ceil(this.list.length / 4);
  }

  firstPage() {
    this.p1 = 1;
  }

  cgPwd() {
    this.chagePassword = true;
  }
}
